const Footer = () => {

    return (
        <p style={{fontSize: '10px', textAlign: 'center', paddingLeft: '0px'}} className="pt-4 text-light">Nahzar Corp &copy; All Rights Reserved.</p>
    )
}

export default Footer